const Hero = ({ children, className = "" }) => {
  return (
    <div className={`text-4xl font-bold w-full ${className}`}>{children}</div>
  );
};
export default Hero;
